<template>
  <div class="arquivos">
    <default-header />
    <v-main>
      <v-container fluid style="height: 100vh;">
        <default-drawer />
      </v-container>
    </v-main>
    <default-footer />
  </div>
</template>

<script>
export default {
  name: "arquivos",
  components: {
    "default-header": () => import("../../home/components/header/index.vue"),
    "default-footer": () => import("../../home/components/footer/index.vue"),
    "default-drawer": () => import("../components/drawer/index.vue")
  }
};
</script>
